import useDispensary from 'dispensary/hooks/use-dispensary';
import useDispensaryFlag from 'shared/hooks/use-dispensary-flag';

type UseHardAgeGateReturn = {
  hardAgeGate: boolean;
  dispensaryLogoImage: string;
};

export function useHardAgeGate(): UseHardAgeGateReturn {
  const { dispensary } = useDispensary();
  const dispensaryLogoImage = dispensary ? dispensary.logoImage : null;
  const hardAgeGate = useDispensaryFlag(`hard-age-gate.hide-menu-content-by-dispensary`, dispensary?.id);
  return { hardAgeGate, dispensaryLogoImage };
}
